/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Center_LeftInputs */



/**
* | output |
* | --- |
* | "Position Center Left" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Center_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_center_left = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Center_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Center_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner au centre gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position Mitte Links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione Centro Sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Центр слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición Centro Izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：中左")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置中央左")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति केंद्र बाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição Central Esquerda")
	return /** @type {LocalizedString} */ ("Position Center Left")
});